export const lessonStatus = [
  { label: 'Registrada tarde', value: 'registrada-tarde' },
  { label: 'Iniciada tarde', value: 'iniciada-tarde' },
  { label: 'Iniciada a tiempo', value: 'iniciada-a-tiempo' },
  {
    label: 'Iniciada sin fecha finalizada',
    value: 'iniciada-sin-fecha-finalizada',
  },
  { label: 'No ejecutada', value: 'no-ejecutada' },
];

export const getLessonStatus = (status: string) => {
  return lessonStatus.find((item) => item.value === status);
};
